const state = {
  isMobile: false,
  // 是否已滚到底部
  isBottom: false,
  nowTime: Date.now(),

  // 极客邦账户信息
  userInfo: {},
  isLogin: null,

  // 用户所填写第一表单信息，通过 /serv/tgo/user/info 接口获取
  baseInfo: {},

  // 申请状态信息
  applyStatusInfo: {
    progress_rate: '', // 申请状态【 当为 4 时，使用 】
    status: '', // 申请状态
    explanation: '', // 当前状态下的解释
    end_date: '' // 过期时间
  },

  globalLayers: []
}

export default state
